module.exports = __webpack_public_path__ + "img/industry_solution2.68219833.png";